import type {
  SetContactsIsEdit,
  SetCurrentPerson,
  SetFormIsValid,
  SetFormIsValidating,
  SetGroupFilter,
  SetNameFilter,
  SetSorter,
  SetSwipedPerson,
  SetTitleFilter,
  SetUpdateIsLoading,
} from "../types";

const setCurrentPerson: SetCurrentPerson = (state, action) => {
  state.currentPerson = action.payload;
};

const setContactsIsEdit: SetContactsIsEdit = (state, action) => {
  state.contactsIsEdit = action.payload;
};

const setFormIsValid: SetFormIsValid = (state, action) => {
  state.formIsValid = action.payload;
};

const setFormIsValidating: SetFormIsValidating = (state, action) => {
  state.formIsValidating = action.payload;
};

const setUpdateIsLoading: SetUpdateIsLoading = (state, action) => {
  state.updateIsLoading = action.payload;
};

const setGroupFilter: SetGroupFilter = (state, action) => {
  state.groupFilter = action.payload;
};

const setNameFilter: SetNameFilter = (state, action) => {
  state.nameFilter = action.payload;
};

const setTitleFilter: SetTitleFilter = (state, action) => {
  state.titleFilter = action.payload;
};

const setSorter: SetSorter = (state, action) => {
  state.sorter = action.payload;
};

const setSwipedPerson: SetSwipedPerson = (state, action) => {
  state.swipedPerson = action.payload;
};

export const reducers = {
  setCurrentPerson,
  setFormIsValidating,
  setUpdateIsLoading,
  setFormIsValid,
  setContactsIsEdit,
  setGroupFilter,
  setNameFilter,
  setSorter,
  setTitleFilter,
  setSwipedPerson,
};
